import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import { ProgressMultiItem, ProgressMulti } from 'twyne-new.ui';

import { LOADING } from 'stores/BaseStore';

import { Card, Loader } from './card';

const propTypes = {
  header: PropTypes.string,
  field: PropTypes.string,
  data: PropTypes.any,
  addFilter: PropTypes.func,
  filterType: PropTypes.string,
};

function ProgressBar({ percent, isRemains, header, onAddFilter }) {
  let color = 'danger'
  const filterValue = `${!isRemains}`
  let tooltipLabel = header

  if (isRemains) {
    color = 'neutral'
    percent = 100 - percent
    tooltipLabel = `Not ${tooltipLabel}`
  }

  tooltipLabel = `${tooltipLabel} - ${percent.toFixed()}%`

  return <ProgressMultiItem
    color={color}
    value={percent}
    tiptap={tooltipLabel}
    className='cursor-pointer'
    onClick={() => onAddFilter(filterValue)}
  />
}

const formatNumber = value => <NumberFormat value={value} displayType="text" thousandSeparator="," />
const formatPercent = value => `${(value * 100).toFixed()}%`

export default function TotalsCard({ onAddFilter, field, header, status, data = {}, total }) {
  const handleAddFilterValue = value => {
    onAddFilter(value)
  }

  return <Card className='gap-0 h-21'>
    <Loader loading={status === LOADING || !data}>
      <span className='mb-4 truncate'>{header}</span>
      <span className='font-bold text-xl twy-text-base-accent flex justify-between items-center'>
        <div className='items-center flex'>
          <span>{formatNumber(data.total)}</span>
          <span className='text-md'>/{formatNumber(total)} </span>
        </div>
        <span className='text-sm'>{formatPercent(data.totalPC)}</span>
      </span>
    </Loader>
    <ProgressMulti size='sm' fadeColor>
      <ProgressBar percent={data.totalPC * 100} onAddFilter={handleAddFilterValue} field={field} header={header} />
      <ProgressBar percent={data.totalPC * 100} isRemains onAddFilter={handleAddFilterValue} field={field} header={header} />
    </ProgressMulti>
  </Card >
}

TotalsCard.propTypes = propTypes;
